import { createContext as t } from "react";
const o = /* @__PURE__ */ t(0);
export {
  o as H
};
//# sourceMappingURL=__utils-fc7746f4.js.map
